<template>
  <div class="box-resumo">
    <div class="box-header">
      <h2>Resumo da Proposta</h2>
      <div class="button-minuta" @click="onGetMinuta()" v-if="step == 3">
        <v-icon class="icon_blue"> picture_as_pdf </v-icon>
        <span>Ver Minuta</span>
      </div>
    </div>

    <div class="box-container">
      <section class="box-modalidade" v-if="corretor">
        <span>Corretor</span>
        <span>{{ formatCNPJAndCPF(corretor.CNPJ) }} - {{ corretor.nome }}</span>
      </section>

      <section v-if="modalidade" class="box-modalidade">
        <span>Modalidade</span>
        <span>{{ modalidade }}</span>
      </section>

      <section v-if="segurado" class="box-segurado">
        <span>Segurado</span>
        <div class="dados-segurado">
          <span style="color: #fff"
            >{{ formatCNPJAndCPF(segurado.cnpj_cpf) }} -
          </span>
          <span style="color: #fff">{{ segurado.nome }}</span>
        </div>
      </section>

      <div class="no-padding-bottom" v-if="taker && segurado && modalidade && product && !taxa_empty">
        <limites-taxas
          :carregando="buscandoLimite"
          :taker="taker"
          :step="4"
          :tipo_pessoa="this.segurado.tipo_pessoa"
          :id_grupo="this.product.id_grupo"
          :erroBuscaLimite="erroBuscaLimite"
          :msgErroBuscaLimite="msgErroBuscaLimite"
        ></limites-taxas>
      </div>

      <section v-if="inicio_vigencia" class="box-vigencia">
        <div v-if="inicio_vigencia" class="item-vigencia">
          <span>Ínicio Vigência</span>
          <span>{{ inicio_vigencia }}</span>
        </div>

        <div class="item-vigencia">
          <span v-if="vigencia_dia && !vigencia_ano">Vigência por Dia</span>
          <span v-if="vigencia_ano && vigencia_dia">Vigência por Ano</span>
          <span v-if="vigencia_dia && !vigencia_ano"
            >{{ vigencia_dia }} Dias</span
          >
          <span v-if="vigencia_ano && vigencia_dia"
            >{{ vigencia_ano }} Anos
            <small>({{ vigencia_dia }} dias)</small></span
          >
        </div>
        <div
          v-if="
            (fim_vigencia || fim_vigencia_ano) && (vigencia_ano || vigencia_dia)
          "
          class="item-vigencia"
        >
          <span>Fim Vigência</span>
          <span v-if="fim_vigencia">{{ fim_vigencia }}</span>
          <span v-if="fim_vigencia_ano">{{ fim_vigencia_ano }}</span>
        </div>
      </section>

      <section class="box-valores" v-if="segurado && modalidade">
        <div v-if="valIsEmpty(valor_recurso)" class="valores">
          <span>Valor Recurso</span>
          <span>{{ valor_recurso }}</span>
        </div>

        <div v-if="valIsEmpty(importancia_segurada)" class="valores">
          <span>Importância Segurada</span>
          <span>{{ toMoneyString(importancia_segurada) }}</span>
        </div>
      </section>

      <section class="box-valores" v-if="segurado && modalidade && valIsEmpty(valor_premio) && valIsEmpty(valor_recurso) && inicio_vigencia && fim_vigencia && vigencia_dia">
        <div v-if="valIsEmpty(valor_premio)" class="valor-premio">
          <span>Valor do Prêmio</span>
          <span>{{ toMoneyString(valor_premio) }}</span>
        </div>
      </section>

      <div
        class="box-objeto"
        v-if="product && product.objeto && (step == 2 || step == 3)"
      >
        <span class="titulo-objeto">Objeto</span>
        <v-card
          class="white-background conteudo-objeto"
          v-html="product.objeto.replace(/(?:\r\n|\r|\n)/g, '<br />')"
        >
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { toMoneyString, formatCNPJAndCPF } from "@/libs/utils";

export default {
  name: "PropostaResumo",
  props: [
    "corretor",
    "segurado",
    "modalidade",
    "valor_recurso",
    "importancia_segurada",
    "valor_premio",
    "inicio_vigencia",
    "fim_vigencia",
    "fim_vigencia_ano",
    "vigencia_dia",
    "vigencia_ano",
    "tomador",
    "product",
    "taker",
    "step",
    "buscandoLimite",
    "TAGs",
    "msgErroBuscaLimite",
    "erroBuscaLimite",
    "taxa_empty"
  ],
  data: () => {
    return {
      toMoneyString,
      formatCNPJAndCPF,
    };
  },
  mounted() {},
  methods: {
    valIsEmpty(val) {

      if (val.toString().toLowerCase() === "R$ 0,00".toString().toLowerCase() || val.toString().toLowerCase() === '0' || !val) {
        return false;
      } else {
        return true;
      }
    },

    emitGetMinuta() {
      this.$emit("getMinuta");
    },

    onGetMinuta() {
      this.$emit("emitGetMinuta");
    },
  },
  watch: {
    buscandoLimite: function (newValue) {
      if (newValue) window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
#jns {
  $whiteColor: #fff;
  $grayLightColor: rgb(202, 202, 202);
  $blueColor: #172c52;
  height: 100%;

  .box-resumo {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 4.5vh;
    font-weight: bold;
    font-size: 0.975rem;

    .box-header {
      width: 80%;
      display: flex;
      justify-content: space-around;
      align-items: center;

      h2 {
        color: $whiteColor;
        font-weight: bold;
      }

      .button-minuta {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 130px;
        height: 35px;
        border-radius: 20px;
        box-shadow: 6px 10px 15px -9px rgba(0, 0, 0, 0.15);
        cursor: pointer;
        background-color: $whiteColor;
        transition: 0.5s opacity;

        img {
          width: 20px;
          margin-top: 4px;
          margin-right: 0.875rem;
        }

        span {
          font-size: 13px;
          font-weight: bolder;
          color: $blueColor;
        }

        .icon_blue {
          color: $blueColor;
          margin-right: 5px;
        }
      }
    }

    .button-minuta:hover {
      opacity: 0.8;
    }

    .box-container {
      width: 90%;
      margin: 0 auto;
      height: 100%;

      .box-valores,
      .box-modalidade,
      .box-vigencia,
      .box-segurado,
      .box-objeto {
        display: flex;
        width: 100%;
        color: $grayLightColor;
        margin-top: 3vh;
      }

      .box-segurado {
        flex-direction: column;
      }

      .box-vigencia {
        margin-top: 0 !important;
      }

      .box-valores {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .valores {
          display: flex;
          flex-direction: column;
          margin-bottom: 1.3vh;

          :last-child {
            color: $whiteColor;
          }
        }

        .valor-premio {
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 100%;
          background-color: $whiteColor;
          color: $blueColor;
          font-size: 1rem;
          border-radius: 2px;
          padding: 1rem;
          margin-bottom: 3vh;

          :last-child {
            color: #d21a5e;
            font-size: 1.2rem;
          }
        }
      }

      .box-objeto {
        flex-direction: column;
        align-items: center;
        padding-bottom: 3vh;

        .titulo-objeto {
          color: $whiteColor;
        }

        .conteudo-objeto {
          font-size: 0.875rem;
          padding: 1rem;
          color:#061D45;
        }
      }

      .box-vigencia {
        display: flex;
        justify-content: space-between;

        .item-vigencia {
          display: flex;
          flex-direction: column;

          :last-child {
            color: $whiteColor;
          }
        }
      }

      .box-modalidade {
        display: flex;
        flex-direction: column;
        :last-child {
          color: $whiteColor;
        }
      }
    }

    .line {
      width: 85%;
      margin: 3vh 0;
      background-color: $grayLightColor;
      height: 1px;
      border-width: 0;
      opacity: 0.3;
    }

    .box-dados {
      display: flex;
      flex-direction: column;
      width: 90%;
      margin: 0 auto;
      color: $grayLightColor;

      .dados {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 3vh;

        :last-child {
          color: $whiteColor;
        }
      }
    }

    @media screen and (max-width: 1500px) { 
      .box-header{
        flex-wrap: wrap;

        .button-minuta{
          margin-top: 2.25vh
        }
      }
    }

    @media screen and (max-width: 450px) {
      .box-vigencia {
        flex-wrap: wrap;
        margin: 0 0 !important;

        .item-vigencia {
          margin: 2.25vh 0 !important;
        }
      }

      .box-valores {
        flex-wrap: wrap;
        margin: 0 0 !important;
        .valores {
          margin: 2.25vh 0 !important;
        }
      }
      
      .box-header{
        flex-wrap: wrap;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PropostaResumo.vue